export default __webpack_public_path__ + "static/media/vishakapatnam.0f758001.png";